export default {
  REQUEST_FETCH_SUPPORTS: 'REQUEST_FETCH_SUPPORTS',
  FETCH_SUPPORTS_ERROR: 'FETCH_SUPPORTS_ERROR',
  FETCH_SUPPORTS_SUCCESS: 'FETCH_SUPPORTS_SUCCESS',
  RESET_SUPPORT: 'RESET_SUPPORT'
}
